import { format } from "date-fns";
import { stringify } from "query-string";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Subject } from "rxjs";
import { generateSequentialArray } from "../../common/utils";
import IconDownNotification from "../../images/ic_down_icon_notification.svg";
import IconUpNotification from "../../images/ic_up_notification.svg";
import CargoAgentCreditAuthorizationNotificationCard from "./CargoAgentCreditAuthorization/CargoAgentCreditAuthorizationNotificationCard";
import { ICargoAgentCreditAuthorization } from "./CargoAgentCreditAuthorization/model";
import { CommonNotification } from "./CommonNotification";
import {
  DivContentCount,
  DivContentDocument,
  DivContentHead,
  DivContentLabel,
  DivContentSymbol,
} from "./CommonNotificationStyles";
import ConsigneeCreditAuthorizationNotificationCard from "./ConsigneeCreditAuthorization/ConsigneeCreditAuthorizationNotificationCard";
import { IConsigneeCreditAuthorization } from "./ConsigneeCreditAuthorization/model";
import { ISenasaNotification } from "./Senasa/model";
import SenasaNotificationCard from "./Senasa/SenasaNotificationCard";
import { IThirdPartyBillingAuthorization } from "./ThirdPartyBillingAuthorization/model";
import ThirdPartyBillingAuthorizationNotificationCard from "./ThirdPartyBillingAuthorization/ThirdPartyBillingAuthorizationNotificationCard";
import { ITurnConfirmation } from "./TurnConfirmation/model";
import TurnConfirmationNotificationCard from "./TurnConfirmation/TurnConfirmationNotificationCard";
import { IUpfrontManualPayment } from "./UpfrontManualPayment/model";
import UpfrontManualPaymenNotificationCard from "./UpfrontManualPayment/UpfrontManualPaymenNotificationCard";

export const FAKE_ARRAY = generateSequentialArray(20);

interface IContentDocumentNotifications {
  endpoints: { type: string; label: string; count: number; symbol: string }[];
  onOutsideClick: any;
  loadCountNotification$: Subject<void>;
}

export const ContentDocumentNotifications = (
  props: IContentDocumentNotifications
) => {
  const { endpoints, onOutsideClick, loadCountNotification$ } = props;

  const [selectedSection, setSelectedSection] = useState("");

  const history = useHistory();

  const redirectOnClickUpfrontManualPayment = (notification) => {
    const volante_nums = notification.invoice.volante_details.map(
      (volante) => volante.volante_num
    );
    const params_url = {
      agent_name: notification.invoice.agent_name,
      volante_nums,
      from_date: format(
        new Date(notification.invoice.reference_time),
        "yyyy-MM-dd"
      ),
    };
    const pathname = "/web/admin/validacion-pagos";
    history.push(`${pathname}?${stringify(params_url)}`);
    onOutsideClick();
  };

  const redirectOnClickCargoAgentCredit = (notification) => {
    const volante_nums = notification.invoice.volante_details.map(
      (volante) => volante.volante_num
    );
    const params_url = {
      agent_name: notification.invoice.agent_name,
      volante_nums,
      documentType:
        notification.invoice.payer_ruc_option === "consignee"
          ? "agent_importer"
          : notification.invoice.payer_ruc_option === "cargo_agent"
          ? "agent_cargo"
          : notification.invoice.payer_ruc_option,
      from_date: format(
        new Date(notification.invoice.reference_time),
        "yyyy-MM-dd"
      ),
    };
    const pathname = "/web/admin/validacion-documentos";
    history.push(`${pathname}?${stringify(params_url)}`);
    onOutsideClick();
  };

  const redirectOnClickSenasa = (notification) => {
    const parts = notification.dam.dam_num.split("-");
    const volante_nums = notification.dam.volante_details.map(
      (volante) => volante.volante_num
    );
    const params_url = {
      /*eslint-disable */
      ["dam.static"]: "235",
      /*eslint-disable */
      ["dam.year"]: parts[1],
      /*eslint-disable */
      ["dam.regimen"]: parts[2],
      /*eslint-disable */
      ["dam.num"]: parts[3],
      volante_nums: volante_nums,
      documentType: "senasa",
      from_date: format(
        new Date(notification.dam.reference_time),
        "yyyy-MM-dd"
      ),
      notification_status: true,
    };

    const pathname = "/web/admin/validacion-documentos";
    history.push(`${pathname}?${stringify(params_url)}`);
    onOutsideClick();
  };

  const redirectOnClickThirdPartyBilling = (notification) => {
    const params_url = {
      agent_name: notification.volante.agent_name,
      volante_nums: notification.volante.volante_num,
      documentType: "third_party_billing_authorization",
      from_date: format(
        new Date(notification.volante.reference_time),
        "yyyy-MM-dd"
      ),
    };
    const pathname = "/web/admin/validacion-documentos";
    history.push(`${pathname}?${stringify(params_url)}`);
    onOutsideClick();
  };

  const redirectOnClickTurnConfirmation = (notification) => {
    const volante_nums = notification.appointment.volante_details.map(
      (volante) => volante.volante_num
    );
    const params_url = {
      agent_name: notification.appointment.agent_name,
      volante_nums,
      withdrawal_from_date: format(
        new Date(notification.appointment.reference_time),
        "yyyy-MM-dd"
      ),
    };
    const pathname = "/web/admin/creacion-turnos";
    history.push(`${pathname}?${stringify(params_url)}`);
    onOutsideClick();
  };

  const redirectOnClickConsigneeCredit = (notification) => {
    const volante_nums = notification.invoice.volante_details.map(
      (volante) => volante.volante_num
    );
    const params_url = {
      agent_name: notification.invoice.agent_name,
      volante_nums,
      documentType:
        notification.invoice.payer_ruc_option === "consignee"
          ? "agent_importer"
          : notification.invoice.payer_ruc_option,
      from_date: format(
        new Date(notification.invoice.reference_time),
        "yyyy-MM-dd"
      ),
    };
    const pathname = "/web/admin/validacion-documentos";
    history.push(`${pathname}?${stringify(params_url)}`);
    onOutsideClick();
  };
  return (
    <div>
      {endpoints.map((endpoint, i) => {
        const selected = selectedSection === endpoint.type;
        return (
          <React.Fragment key={i}>
            {endpoint.count > 0 && (
              <DivContentDocument>
                <DivContentHead
                  paddingBottom={`${selected ? "0rem" : "2rem"}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedSection((selectedSection) =>
                      selectedSection === endpoint.type ? "" : endpoint.type
                    );
                  }}
                >
                  <DivContentSymbol>{endpoint.symbol}</DivContentSymbol>
                  <DivContentLabel>
                    {endpoint.label.toUpperCase()}
                  </DivContentLabel>
                  <DivContentCount>{endpoint.count}</DivContentCount>
                  <img
                    src={selected ? IconUpNotification : IconDownNotification}
                    alt=""
                  />
                </DivContentHead>
                {selected && (
                  <>
                    {selectedSection === "senasa" && (
                      <CommonNotification<ISenasaNotification>
                        url="/notifications/senasa/"
                        authorization="notifications.update_notification_senasa"
                        notificationTemplate={(props) => (
                          <SenasaNotificationCard
                            key={props.notification.notification_id}
                            {...props}
                          />
                        )}
                        buildDeleteUrl={(notificationId) => {
                          return `/notifications/senasa/${notificationId}/hide/`;
                        }}
                        redirectOnClick={redirectOnClickSenasa}
                        loadCountNotification$={loadCountNotification$}
                      />
                    )}
                    {selectedSection ===
                      "third_party_billing_authorization" && (
                      <CommonNotification<IThirdPartyBillingAuthorization>
                        url="/notifications/third-party-billing-auth/"
                        authorization="notifications.update_notification_third_party_billing_authorization"
                        notificationTemplate={(props) => (
                          <ThirdPartyBillingAuthorizationNotificationCard
                            key={props.notification.notification_id}
                            {...props}
                          />
                        )}
                        buildDeleteUrl={(notificationId) => {
                          return `/notifications/third-party-billing-auth/${notificationId}/hide/`;
                        }}
                        redirectOnClick={redirectOnClickThirdPartyBilling}
                        loadCountNotification$={loadCountNotification$}
                      />
                    )}

                    {selectedSection === "cargo_agent_credit_authorization" && (
                      <CommonNotification<ICargoAgentCreditAuthorization>
                        url="/notifications/cargo-agent-credit-auth/"
                        authorization="notifications.update_notification_cargo_agent_credit_authorization"
                        notificationTemplate={(props) => (
                          <CargoAgentCreditAuthorizationNotificationCard
                            key={props.notification.notification_id}
                            {...props}
                          />
                        )}
                        buildDeleteUrl={(notificationId) => {
                          return `/notifications/cargo-agent-credit-auth/${notificationId}/hide/`;
                        }}
                        redirectOnClick={redirectOnClickCargoAgentCredit}
                        loadCountNotification$={loadCountNotification$}
                      />
                    )}
                    {selectedSection === "consignee_credit_authorization" && (
                      <CommonNotification<IConsigneeCreditAuthorization>
                        url="/notifications/consignee-credit-auth/"
                        authorization="notifications.update_notification_consignee_credit_authorization"
                        notificationTemplate={(props) => (
                          <ConsigneeCreditAuthorizationNotificationCard
                            key={props.notification.notification_id}
                            {...props}
                          />
                        )}
                        buildDeleteUrl={(notificationId) => {
                          return `/notifications/consignee-credit-auth/${notificationId}/hide/`;
                        }}
                        redirectOnClick={redirectOnClickConsigneeCredit}
                        loadCountNotification$={loadCountNotification$}
                      />
                    )}
                    {selectedSection === "third_party_credit_authorization" && (
                      <CommonNotification<ICargoAgentCreditAuthorization>
                        url="/notifications/third-party-credit-auth/"
                        authorization="notifications.update_notification_third_party_credit_authorization"
                        notificationTemplate={(props) => (
                          // TODO: Parece q se repite
                          <CargoAgentCreditAuthorizationNotificationCard
                            key={props.notification.notification_id}
                            {...props}
                          />
                        )}
                        buildDeleteUrl={(notificationId) => {
                          return `/notifications/third-party-credit-auth/${notificationId}/hide/`;
                        }}
                        redirectOnClick={redirectOnClickCargoAgentCredit}
                        loadCountNotification$={loadCountNotification$}
                      />
                    )}
                    {/* Pagos */}
                    {selectedSection === "upfront_manual_payment" && (
                      <CommonNotification<IUpfrontManualPayment>
                        url="/notifications/upfront-manual-payment/"
                        authorization="notifications.update_notification_upfront_manual_payment"
                        notificationTemplate={(props) => (
                          <UpfrontManualPaymenNotificationCard
                            key={props.notification.notification_id}
                            {...props}
                          />
                        )}
                        buildDeleteUrl={(notificationId) => {
                          return `/notifications/upfront-manual-payment/${notificationId}/hide/`;
                        }}
                        redirectOnClick={redirectOnClickUpfrontManualPayment}
                        loadCountNotification$={loadCountNotification$}
                      />
                    )}
                    {/* Turnos */}
                    {selectedSection === "turn_confirmation" && (
                      <CommonNotification<ITurnConfirmation>
                        url="/notifications/turn-confirmation/"
                        authorization="notifications.update_notification_turn_confirmation"
                        notificationTemplate={(props) => (
                          <TurnConfirmationNotificationCard
                            key={props.notification.notification_id}
                            {...props}
                          />
                        )}
                        buildDeleteUrl={(notificationId) => {
                          return `/notifications/turn-confirmation/${notificationId}/hide/`;
                        }}
                        redirectOnClick={redirectOnClickTurnConfirmation}
                        loadCountNotification$={loadCountNotification$}
                      />
                    )}
                  </>
                )}
              </DivContentDocument>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
